// extracted by mini-css-extract-plugin
export var completionBody = "_gs-2";
export var completionCard = "_gs-0";
export var completionFooter = "_gs-3";
export var completionTitle = "_gs-1";